module.exports = __webpack_public_path__ + "static/media/share-white.085757ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/share-white.svg
// module id = 253
// module chunks = 0